<template>
  <div class="tw-flex">
    <div
      :class="[
        'custom-global-skeleton tw-bg-[#ffffff] tw-max-h-[112px] tw-min-h-[112px] tw-min-w-[200px] tw-w-full tw-h-full tw-flex tw-flex-col tw-justify-between tw-items-start tw-flex-[1_0_0] tw-self-stretch tw-border tw-shadow-[0px_0px_4px_0px_rgba(0,0,0,0.05)] tw-p-5 tw-rounded-l-md tw-border-solid tw-border-[#EFF0F1]',
      ]"
    >
      <!--
 <div class="tw-flex tw-justify-between tw-w-full">
        <div class="custom-global-skeleton-pulse tw-h-[15px] tw-w-[60px]"></div>
        <div
          class="custom-global-skeleton-pulse tw-h-[22.5px] tw-w-[60px] tw-ml-[10px] cell-status tw-flex tw-items-center tw-text-[11px] tw-font-[500] tw-rounded"
        ></div>
      </div>
      <div class="tw-flex tw-flex-col tw-w-full tw-mt-[10px]">
        <div class="tw-flex tw-justify-between tw-w-full">
          <div
            class="custom-global-skeleton-pulse tw-h-[13px] tw-w-[60px] tw-mb-[10px]"
          ></div>
          <div class="tw-text-[#B7B7B7] tw-text-[13px] tw-font-[400]">
            <div
              class="custom-global-skeleton-pulse tw-h-[13px] tw-w-[60px]"
            ></div>
          </div>
        </div>

        <div class="tw-flex tw-justify-between tw-w-full">
          <div
            class="custom-global-skeleton-pulse tw-h-[13px] tw-w-[80px] tw-mb-[10px]"
          ></div>
          <div
            class="tw-text-[#211F58] tw-text-[13px] tw-not-italic tw-font-medium tw-leading-[130%] title"
          >
            <div class="tw-text-[#B7B7B7] tw-text-[13px] tw-font-[400]">
              <div
                class="custom-global-skeleton-pulse tw-h-[13px] tw-w-[80px]"
              ></div>
            </div>
          </div>
        </div>
      </div> 
-->
    </div>

    <div
      :class="[
        'tw-p-[20px] tw-bg-[#ffffff] tw-max-h-[112px] tw-max-w-[112px] tw-rounded-r-md tw-border tw-border-solid tw-border-[#EFF0F1] tw-shadow-[0px_0px_4px_0px_rgba(0,0,0,0.05)]',
      ]"
    >
      <div class="skeleton-radial custom-global-skeleton-pulse"></div>
    </div>
  </div>
</template>

<style scoped>
.skeleton-radial {
  width: 72px;
  height: 72px;
  border-radius: 50%;
}
</style>
